import { registerSW } from 'virtual:pwa-register';
import { reportClientError } from './telemetry';

/** Register the service worker (auto-update). Called once from main.tsx in production builds. */
export function setupPwa(): void {
  if (!import.meta.env.PROD) return;
  registerSW({
    immediate: true,
    // a failing service worker means no offline shell for caddies in the field: report it
    onRegisterError: (err: unknown) => reportClientError('sw', err, { stage: 'register' }),
  });
}
